angular
	.module 'App.Service'
	.service 'ToastService', ($filter) ->
		@_callbacks = []
		@_options =
			ttl: 5000
			type: 'info'
		@_defaultToastResponse =
			success: false
			error: false
			objectName: null

		###
		message - Message text to be shown
		object - Title string to be shown
		action - Type of action. E.g. error/info/update/etc
		type - Type of message. Possible values: error|success|info
		ttl - Time-To-Live - how long to show message. Default 5000
		###
		@add = (messages, title, action, type, ttl) ->
			if messages and angular.isString messages
				messages = [messages]

			toast =
				messages: messages ? [],
				type: if type then type.toString() else @_options.type,
				ttl: if ttl then parseInt(ttl, 10) else @_options.ttl,
				show: true
				object: title ? null
				action: action ? null
				timestamp: _.now()

			for callback in @_callbacks
				callback(toast)

		@subscribe = (callback) ->
			@_callbacks.push callback

		@unsubscribe = (callback) ->
			@_callbacks.pop callback

		# Sets whenever to show default toast message on success or error responses.
		# Call before $http, $q (ModelRepository) request to enable default toast
		# Used in HttpInterceptor to reset before returning promise
		@setDefaultToastResponse = (successResponse, errorResponse, objectName = null) ->
			@_defaultToastResponse.success = successResponse
			@_defaultToastResponse.error = errorResponse
			@_defaultToastResponse.objectName = if objectName then objectName else $filter('translate')('general.record')

		@getDefaultToastResponse = () ->
			return @_defaultToastResponse

		@showDefaultSuccess = (response) ->
			if @_defaultToastResponse.success
				@add(
					null,
					@_defaultToastResponse.objectName,
					$filter('wmApiActionResult')(response.config.method),
					'info'
				)
			@setDefaultToastResponse false, false

		@showDefaultError = (response) ->
			if @_defaultToastResponse.error && response?
				if response.data?.error?
					@add(
						response.data.error + @parseErrors(response),
						@_defaultToastResponse.objectName,
						$filter('wmApiActionResult')(response.config.method, true),
						'error'
					)

		@parseWarnings = (response) ->
			if typeof response == 'string'
				return [response]

			# If response is $q service type response, use only response.data
			if angular.isDefined(response.data) && angular.isDefined(response.xhrStatus)
				response = response.data

			warnings = []

			if response.__warnings?
				response = response.__warnings

			angular.forEach response, (warning) =>
				if typeof warning != 'string'
					angular.forEach warning, (innerWarnings) =>
						warnings = warnings.concat(@parseWarnings(innerWarnings))
				else
					warnings.push warning

			return warnings

		@parseErrors = (response) ->
			if !response?
				return

			errors = []

			if typeof response == 'string'
				errors.push response

				return errors

			# If response is $q service type response, use only response.data
			if response.data? && response.xhrStatus?
				response = response.data

			if response.error?
				if angular.isString response.error
					errors.push response.error
				else
					response.errors = response.error

			if response.message?
				errors.push response.message

			if response.errors?
				angular.forEach response.errors, (error) =>
					if typeof error != 'string'
						angular.forEach error, (innerErrors) =>
							errors = errors.concat(@parseErrors(innerErrors))
					else
						errors.push error

			return errors

		@showWarnings = (response, object = null) ->
			warnings = @parseWarnings response
			@add warnings, object, $filter('translate')('general.warning'), 'warning'

		@showErrors = (response, object = null) ->
			errors = @parseErrors response
			@add errors, object, $filter('translate')('general.error'), 'error'

		return
